import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { ColumnDefinition } from 'components';
import { of } from 'rxjs';
import { catchError, map, take, filter } from 'rxjs/operators';
import { BaseReportGridSource } from '../base-report-grid-source';
import { ReportWrapperService } from '../../../../core/services/service-wrappers/report-wrapper.service';
import { DateDisplayPipe } from 'projects/components/src/lib/shared/pipes/date-display/date-display.pipe';
import { saveAs } from 'file-saver';
import { getSelectedDataSetId } from 'src/app/core/state/data-set/data-set.selectors';
import { Store } from '@ngrx/store';
import { DialogService } from '../../../../core/services/dialog.service';
import { NotificationService } from '../../../../core/services/notification.service';
import { QueuesWrapperService } from '../../../../core/services/service-wrappers/queues-wrapper.service';
import { MatDialog } from '@angular/material/dialog';
import { BillClaimComponent } from '../../../queues/dialogs/bill-claim/bill-claim.component';
import { DialogContent } from 'components';

@Injectable({
  providedIn: 'root'
})
export class UnbilledChargesService extends BaseReportGridSource<any> {
  datasetId$ = this.baseStore.select(getSelectedDataSetId).pipe(filter((cId) => !!cId));
  datasetId;
  private query;

  constructor(
    private reportService: ReportWrapperService,
    @Inject(LOCALE_ID) private locale: string,
    private baseStore: Store<any>,
    private queuesWrapperService: QueuesWrapperService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private dialog: MatDialog
  ) {
    super();
    this.datasetId$.subscribe((datasetIdFromStore) => {
      this.datasetId = datasetIdFromStore;
    });

  }
  datePipe: DateDisplayPipe = new DateDisplayPipe(this.locale);
  initialize(query: any, columnDefinitions: ColumnDefinition[]) {
    this.query = query;
    this.gridColumns = columnDefinitions;
    const request = {
      slug: query.slug,
      datasetId: this.datasetId,
      attendingProviderIds: query.attendingProviderIds?.join(',') ?? '',
      insuranceCarrierIds: query.insuranceCarrierIds?.join(',') ?? '',
      financialClassIds: query.financialClassIds?.join(',') ?? '',
      reportFormat: query.reportFormat,
      dateRangeType: query.dateRangeType,
      dateRangeStart: this.datePipe.transform(query.dateRangeStart),
      dateRangeEnd: this.datePipe.transform(query.dateRangeEnd),
      excludeZeroBalanceClaims: query.excludeZeroBalanceClaims,
      procedureCodeIds: query.procedureCodeIds?.join(',') ?? '',
      includeExcludeProcedures: query.includeExcludeProcedures,
      textParameters: this.textParameters
    };
    this.loadInitialData(
      this.reportService.apiV1ReportPost(request).pipe(
        map((x) => {
          this.textParameters['User'] = x.processedBy;
          this.datasetName = x.datasetName;
          this.reportExecutionId = x.reportExecutionId;
          this.resultColumns = x.columns;
          return x.data.map((data) => {
            return { ...data };
          });
        }),
        catchError(() => of([]))
      )
    );
  }

  openBillClaimModal(data: any): void {
    const dialog = this.dialog.open(BillClaimComponent, {
      disableClose: true,
      autoFocus: false,
      data: { ...data, rebill: true }
    });

    dialog.afterClosed().subscribe((result) => {
      if (result === true) {
        this.initialize(this.query, this.gridColumns);
      }
    });
  }

  rebillMultiple(selection): void {
    if (!selection?.selected?.length) {
      return;
    }

    const selectedItems = [...selection?.selected];
    let selectionVisitIds = [...new Set(selectedItems?.map(item => item.visitId).filter(visitId => visitId !== ''))] ;
    const modalContent: DialogContent = {
      header: '',
      body: 'Are you sure you want to rebill all selected records?',
      cancelButtonText: 'Back',
      OKButtonText: 'Confirm',
      observable: this.queuesWrapperService
        .apiV1NoResponseVisitsRebillMultiplePost(selectionVisitIds)
        .pipe(map((x) => x)),
      errorMessage: 'Error rebilling claims.'
    };

    this.dialogService.showConfirmDialog(modalContent).subscribe((result) => {
      if (result) {
        this.notificationService.success('Claims have been rebilled.');
        this.initialize(this.query, this.gridColumns);
      }
    });
  }
}
